<template>
  <div style="float: left; padding-right: 40px;">
    <div class="add-npa-row">
      <a
        @click="resetForm(true)"
        class="print-excel"
      >
        <i class="word-i"></i>
        {{ $t("Результаты охоты") }}
      </a>
    </div>
    <v-dialog v-model="excelResultDialog" max-width="640">
      <v-card class="modal event-modal">
        <div class="modal-head">
          <template>
            {{ $t('Результаты охоты') }}
          </template>
          <v-btn color="modal-close" @click="resetForm()">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="printResultReport"
          >
            <v-row :class="{ invalid: $v.resultReport.year.$error }">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Год') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Год')"/>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-select
                    :items="refYears"
                    item-value="id"
                    item-text="transName"
                    v-model="resultReport.year"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <v-row :class="{ invalid: $v.resultReport.soate.$error }" v-if="soates.length > 1">
              <v-col cols="4" md="4" class="input-label">
                <v-label>{{ $t('Область') }}: <span class="asterix">*</span></v-label>
                <fieldInfo :info="$t('Область')"/>
              </v-col>
              <v-col class="input-field">
                <div class="select-def">
                  <v-autocomplete
                    :items="soates"
                    item-value="id"
                    item-text="transName"
                    v-model="resultReport.soate"
                    outlined
                    dense
                    clearable
                  />
                </div>
              </v-col>
            </v-row>
            <!--Кнопки действии-->
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
              >
                {{ $t('Генерировать') }}
              </button>
              <button
                class="btn btn-default gray"
                type="button"
                @click="resetForm()"
              >
                {{ $t('Отмена') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fieldInfo from '@/components/app/fieldInfo'
import { required, requiredIf } from 'vuelidate/lib/validators'
import PermitReport from '@/model/permitReport'

export default {
  props: {
    refYears: Array,
    soates: Array
  },
  components: {
    fieldInfo
  },
  data: () => ({
    excelResultDialog: false,
    resultReport: {},
    rules: {
      resultReport: {
        year: { required },
        soate: {
          required: requiredIf(
            function () {
              return this.soates.length > 1
            })
        }
      }
    }
  }),
  validations () {
    return this.rules
  },
  methods: {
    resetForm (flag = false) {
      this.resultReport = {}
      this.$v.$reset()
      this.excelResultDialog = flag
    },
    printResultReport () {
      if (!this.validateForm()) {
        return
      }
      if (this.soates.length === 1) {
        const soateId = this.soates[0]
        this.resultReport.soate = soateId.id
      }
      PermitReport.generateHuntingResultReportExcel(this.resultReport.year, this.resultReport.soate)
        .then(res => {
          if (res.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(res)
          }
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // генерация ссылки для скачивания xlsx файла
    forceFileDownload (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'result.xlsx')
      document.body.appendChild(link)
      link.click()
      this.resetForm()
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    }
  }
}
</script>
